export default {
  //TODO: 910添加

  namespaced: true,
  state: {
    /**
     * 'mul'|'exce' coupute mul-乘法计算 exce-除法计算
     */
    // coupute:"mul",
    unit: "mm",
    proportion: {
      mmexpx: 5,
      mmexdo: 100,
      pxexdo: 20
    }
  },
  actions: {},
  mutations: {
    CHANGECOMPUTE(state, values) {
      if (values === true) {
        state.unit = "px";
      } else if (values === false) {
        state.unit = "mm";
      }else if(values==="px"||values==='mm'){
        state.unit = values;
      }

    }
  }
};
